import { useAppTranslation, useBackToShop } from "@/utils";
import { CloseCircleFilled } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

interface FailedProps {
  onRetry?: () => void;
  message: string;
}
const PayGetOrderChequeInquiryFailed = ({ message, onRetry }: FailedProps) => {
  const { t } = useAppTranslation();

  const { backToShop, shopName } = useBackToShop();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!" gap={"middle"} align="center">
      <Flex vertical align="center" gap={"large"} className="tw:my-auto tw:w-full">
        <CloseCircleFilled width={80} className="tw:fill-color-error" />
        <Flex vertical gap={"middle"} align="center" className="tw:mt-1!">
          <Typography.Title level={5} className="tw:m-0! tw:font-semibold!">
            {onRetry
              ? t("pay.getOrder.steps.chequeInquiry.unAvailableTitle")
              : t("pay.getOrder.steps.chequeInquiry.unAvailableContent")}
          </Typography.Title>
          {onRetry ? <Typography.Text>{message}</Typography.Text> : null}
        </Flex>
      </Flex>

      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        {onRetry ? (
          <Button
            type="default"
            block
            onClick={() => {
              if (!onRetry) return;
              onRetry();
            }}
          >
            {t("pay.getOrder.steps.chequeInquiry.returnToChequeInquiry")}
          </Button>
        ) : (
          <Button
            block
            onClick={() => {
              backToShop();
            }}
          >
            {t("common.returnTo", { name: shopName })}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default PayGetOrderChequeInquiryFailed;
